import {register, CloudObject, defineProperty} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class APIKey extends CloudObject {
    /**
     * @return {string}
     */
    getSourcingToolShortName() {
        return this.get(APIKey.sourcingToolShortNameProp);
    }

    /**
     * @return {string}
     */
    getThreeLettersId() {
        return this.get(APIKey.threeLettersIdProp);
    }
}

// Hardcoded tags
register('018f8677d823d2389365', APIKey);
APIKey.sourcingToolNameProp = defineProperty('018f8677fee9f8fcb313');
APIKey.encryptedAPIKeyProp = defineProperty('018f86786606a5817fc8');
APIKey.hashedAPIKeyProp = defineProperty('018fa0f59d8296265017');
APIKey.sourcingToolShortNameProp = defineProperty('018f868f58b7425b9f53');
APIKey.sourcingToolShortNameProp = defineProperty('018f868f58b7425b9f53');
APIKey.threeLettersIdProp = defineProperty('019a9748992e5d21c513');
